import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import * as DOCUMENT_NAME from '../../constants/documentNames';
import * as SIGNERS from '../../constants/signers';

const firebaseRef = firebase.database();

export default async function getDocumentStatusByDocumentName(
	leadId,
	documentName,
	callback
) {
	await firebaseRef
		.ref('/kavtek_agreements/' + PROJECT_CODE.projectCode + '/' + leadId)
		.on('value', (snapshot) => {
			// @TODO:
			// Step one search document inside the documentInformation (inside signature requests and signatureRequestsExtras)
			//step two compare the name, for ex if the name is APS Glenridge Amrbria, search through that
			// step three go through all the signatures node. Need to foreach through each of them

			var documentInformationObj = snapshot.val()?.documentInformation;

			// console.log('documentInformationObj', documentInformationObj);

			// console.log('documentName', leadId, documentName);
			// console.log('documentName', DOCUMENT_NAME.aps);
			if (
				documentName === DOCUMENT_NAME.aps ||
				documentName === DOCUMENT_NAME.condo_docs
			) {
				var signatureRequestsObj =
					documentInformationObj &&
					documentInformationObj['signatureRequests'];

				// console.log('signatureRequestsObj', signatureRequestsObj);

				var signatureRequestsObjKeys =
					signatureRequestsObj && Object.keys(signatureRequestsObj);

				var keyFound;

				//searching for the doc name
				signatureRequestsObjKeys?.forEach((key) => {
					var subjectName =
						signatureRequestsObj &&
						signatureRequestsObj[key]['subject'];

					if (subjectName === documentName) {
						keyFound = key;
					}
				});

				var subjectName =
					signatureRequestsObj &&
					keyFound &&
					signatureRequestsObj[keyFound]['subject'];
				var timestamp =
					signatureRequestsObj &&
					keyFound &&
					signatureRequestsObj[keyFound]['timestamp'];

				// console.log('subjectName', subjectName);

				//start searching for the signatures
				var signatureUpdatesObj =
					keyFound &&
					signatureRequestsObj[keyFound]['signatureUpdates'];

				//get the latest update
				var signatureUpdatesObjKeys =
					signatureUpdatesObj && Object?.keys(signatureUpdatesObj);
				var latestUpdateKey =
					signatureUpdatesObjKeys &&
					signatureUpdatesObjKeys[
						signatureUpdatesObjKeys?.length - 1
					];

				//get the actual signatures
				var signaturesObj =
					signatureUpdatesObj &&
					signatureUpdatesObj[latestUpdateKey]['signature_request'][
						'signatures'
					];

				//get the event
				var eventType =
					signatureUpdatesObj &&
					signatureUpdatesObj[latestUpdateKey]['event']['event_type'];

				var purchasersAmount;

				//get the signature obj keys

				var signaturesObjKeys =
					signaturesObj && Object.keys(signaturesObj);

				//get the amount of signers
				purchasersAmount =
					signaturesObjKeys && signaturesObjKeys.length;

				var signatureStatusArr = [];

				var latestStatus = {
					timestamp: timestamp,
					eventType: eventType,
				};

				// get the status codes

				signaturesObjKeys &&
					signaturesObjKeys.forEach((key) => {
						var statusCode = signaturesObj[key]['status_code'];
						var signerRole = signaturesObj[key]['signer_role'];

						var signerObj = {
							statusCode: statusCode,
							signerRole: signerRole,
						};

						signatureStatusArr.push(signerObj);
					});

				// console.log('signatureStatusArr', signatureStatusArr);
				if (
					subjectName === DOCUMENT_NAME.aps &&
					subjectName === documentName
				) {
					//check how many purchasers there are
					latestStatus['documentName'] = 'APS';
					if (
						purchasersAmount ===
						SIGNERS.one_purchaser_signers.length
					) {
						// console.log('purchasersAmount', purchasersAmount);
						signatureStatusArr.find((item) => {
							// console.log('This is the result', item.statusCode);
							if (item.signerRole === 'Client') {
								if (item.statusCode === 'signed') {
									latestStatus['status'] = 'client_signed';
								}
							}

							if (item.signerRole === 'Admin') {
								if (item.statusCode === 'signed') {
									latestStatus['status'] = 'admin_signed';
									console.log(
										'getDocumentStatus signerRole admin',
										latestStatus
									);
								}
							}

							if (item.signerRole === 'Builder') {
								if (item.statusCode === 'signed') {
									latestStatus['status'] = 'builder_signed';
								}
							}
						});
					} else if (
						purchasersAmount ===
						SIGNERS.two_purchaser_signers.length
					) {
						signatureStatusArr.find((item) => {
							// console.log('This is the result', item.statusCode);
							if (item.signerRole === 'Client') {
								if (item.statusCode === 'signed') {
									latestStatus['status'] = 'client_signed';
								}
							}

							if (item.signerRole === 'Second Purchaser') {
								if (item.statusCode === 'signed') {
									latestStatus['status'] =
										'second_client_signed';
								}
							}

							if (item.signerRole === 'Admin') {
								if (item.statusCode === 'signed') {
									latestStatus['status'] = 'admin_signed';
								}
							}

							if (item.signerRole === 'Builder') {
								if (item.statusCode === 'signed') {
									latestStatus['status'] = 'builder_signed';
								}
							}
						});
					}

					console.log(' in getDocyumentSateus if aps', latestStatus);
					callback(latestStatus);
				} else if (
					subjectName === DOCUMENT_NAME.condo_docs &&
					subjectName === documentName
				) {
					console.log(
						"signatureRequestsObj[keyFound]['created_at']",
						signatureRequestsObj[keyFound]['created_at']
					);
					latestStatus['documentName'] = 'Condo Docs';
					latestStatus['timestamp'] =
						signatureRequestsObj[keyFound]['created_at'] * 1000;
					//if subject is condo docs
					//check how many purchasers there are

					console.log('line 208 latestStatat', latestStatus);
					if (
						purchasersAmount ===
						SIGNERS.one_purchaser_signers_condo_docs.length
					) {
						console.log(
							'purchasersAmount condo docs',
							purchasersAmount
						);
						signatureStatusArr.find((item) => {
							// console.log('This is the result', item.statusCode);
							if (item.signerRole === 'Client') {
								if (item.statusCode === 'signed') {
									latestStatus['status'] = 'builder_signed';
									console.log(
										'latestStatus statuts',
										latestStatus
									);
								}
							}
						});
					} else if (
						purchasersAmount ===
						SIGNERS.two_purchaser_signers_condo_docs.length
					) {
						console.log('Condo docs 2 purchaser');
						signatureStatusArr.find((item) => {
							// console.log('This is the result', item.statusCode);
							if (item.signerRole === 'Client') {
								if (item?.statusCode === 'signed') {
									latestStatus['status'] = 'Client Signed';
								}
							}

							if (item.signerRole === 'Second Purchaser') {
								if (item?.statusCode === 'signed') {
									latestStatus['status'] = 'builder_signed';
								}
							}
						});
					}

					console.log('latest status condo docs here', latestStatus);

					callback(latestStatus);
				}
			} else {
				var signatureRequestsObj =
					documentInformationObj &&
					documentInformationObj['signatureRequestsExtras'];

				console.log(
					'signatureRequestsObj extradocs',
					signatureRequestsObj
				);

				var signatureRequestsObjKeys =
					signatureRequestsObj && Object.keys(signatureRequestsObj);

				var keyFound;

				//searching for the doc name
				signatureRequestsObjKeys?.forEach((key) => {
					var subjectName =
						signatureRequestsObj &&
						signatureRequestsObj[key]['subject'];

					if (subjectName === documentName) {
						keyFound = key;
					}
				});

				var subjectName =
					signatureRequestsObj &&
					keyFound &&
					signatureRequestsObj[keyFound]['subject'];
				var timestamp =
					signatureRequestsObj &&
					keyFound &&
					signatureRequestsObj[keyFound]['timestamp'];

				// console.log('subjectName', subjectName);

				//start searching for the signatures
				var signatureUpdatesObj =
					keyFound &&
					signatureRequestsObj[keyFound]['signatureUpdates'];

				//get the latest update
				var signatureUpdatesObjKeys =
					signatureUpdatesObj && Object?.keys(signatureUpdatesObj);
				var latestUpdateKey =
					signatureUpdatesObjKeys &&
					signatureUpdatesObjKeys[
						signatureUpdatesObjKeys?.length - 1
					];

				//get the actual signatures
				var signaturesObj =
					signatureUpdatesObj &&
					signatureUpdatesObj[latestUpdateKey]['signature_request'][
						'signatures'
					];

				//get the eventType
				var eventType =
					signatureUpdatesObj &&
					signatureUpdatesObj[latestUpdateKey]['event']['event_type'];

				console.log('signaturesObjsignaturesObj', signaturesObj);

				var purchasersAmount;

				//get the signature obj keys

				var signaturesObjKeys =
					signaturesObj && Object.keys(signaturesObj);

				//get the amount of signers
				purchasersAmount =
					signaturesObjKeys && signaturesObjKeys.length;

				var signatureStatusArr = [];

				var latestStatus = {
					documentName: documentName,
					timestamp: timestamp,
					eventType: eventType,
				};

				// get the status codes

				signaturesObjKeys &&
					signaturesObjKeys.forEach((key) => {
						var statusCode = signaturesObj[key]['status_code'];
						var signerRole = signaturesObj[key]['signer_role'];

						var color;

						if (statusCode === 'awaiting_signature') {
							color = 'var(--warning)';
						} else if (statusCode === 'signed') {
							color = 'var(--success)';
						}

						var signerObj = {
							statusCode: statusCode,
							signerRole: signerRole,
							color: color,
						};

						signatureStatusArr.push(signerObj);
					});

				let lastSignedIndex = signatureStatusArr
					.map((status) => status.statusCode)
					.lastIndexOf('signed');
				signatureStatusArr.forEach((status, index) => {
					if (index >= lastSignedIndex + 2) {
						status.color = 'none';
					}
				});

				latestStatus['extras'] = signatureStatusArr;

				var arraySig = [];

				signatureStatusArr.forEach((signature) => {
					arraySig.push(signature.statusCode);
				});

				if (
					arraySig.every((val, i, arr) => val === 'signed') === true
				) {
					latestStatus['status'] = 'builder_signed';
				}

				console.log('latestStatus extra docs', latestStatus);
				callback(latestStatus);
			}
		});
}
